var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [(_vm.model)?_c('b-form-radio-group',{attrs:{"options":_vm.options,"aria-describedby":ariaDescribedby,"button-variant":"outline-primary","name":"radio-btn-outline","buttons":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }